const purchase = {
  code: "Mã nhà cung cấp",
  name: "Tên nhà cung cấp",
  shortName: "Tên viết tắt",
  country: "Quốc tịch/Khu vực",
  address: "Địa chỉ",
  zipCode: "Mã bưu điện",
  email: "Địa chỉ Email",
  contact: "Người liên hệ",
  phone: "Điện thoại",
  fax: "Fax",
  mobile: "Di động",
  account1: "Ngân hàng 1",
  bank1: "Số tài khoản 1",
  swiftCode1: "Mã Ngân hàng 1",
  account2: "Ngân hàng 2",
  bank2: "Số tài khoản 2",
  swiftCode2: "Mã Ngân hàng 2",
  creditLevel: "Hạng tín dụng",
  creditLine: "Hạn mức tín dụng",
  depositRate: "Tỷ lệ đặt cọc(%)",
  tradeTerm: "Điều kiện thương mại",
  payMethod: "Phương thức thanh toán",
  affiliates: "Công ty liên quan",
  org: "Bộ phận quản lý",
  taxRate: "Thuế suất（%）",
  taxRate1: "Thuế suất",
  billingDays: "Kỳ hạn thanh toán(ngày)",
  principal: "Bên ủy thác",
  relatedDocuments: "Tài liệu liên quan (Hợp đồng/Giấy phép kinh doanh/Chứng từ hóa đơn)",
  price: "Giá",
  plCode: "Nhập mã nhà cung cấp",
  plName: "Nhập tên nhà cung cấp",
  plShortName: "Nhập tên viết tắt",
  plAddress: "Nhập địa chỉ nhà cung cấp",
  plZipCode: "Nhập mã bưu điện nhà cung cấp",
  plEmail: "Nhập Email nhà cung cấp",
  plContact: "Nhập người liên hệ",
  plPhone: "Nhập số điện thoại nhà cung cấp",
  plFax: "Nhập số fax nhà cung cấp",
  plMobile: "Nhập số di động nhà cung cấp",
  plBank1: "Nhập số tài khoản 1",
  plAccount1: "Nhập ngân hàng 1",
  plSwiftCode1: "Nhập mã ngân hàng 1",
  plBank2: "Nhập số tài khoản 2",
  plAccount2: "Nhập ngân hàng 2",
  plSwiftCode2: "Nhập mã ngân hàng 2",
  plCreditLine: "Nhập hạn mức tín dụng",
  plDepositRate: "Nhập tỷ lệ đặt cọc",
  plTradeTerms: "Chọn điều kiện thương mại",
  plPaymentMethod: "Chọn phương thức thanh toán",
  plAffiliates: "Nhập công ty liên quan",
  plTaxRate: "Nhập thuế suất",
  plBillingDays: "Nhập kỳ hạn thanh toán",
  plPrincipal: "Nhập bên ủy thác",
  wmsApi: "API nhà cung cấp",
  plWmsApi: "Nhập API nhà cung cấp",
  customerList: "Danh sách nhà cung cấp",
  addCustomer: "Thêm nhà cung cấp",
  documents: "Tài liệu liên quan",
  codeExisted: 'Mã nhà cung cấp đã tồn tại',
  supplierNotExisted: "Nhà cung cấp không tồn tại",
  stPrice: 'Đơn giá đã bao gồm thuế',
  priceExisted: 'Sản phẩm này đã có giá, không cần thêm lại',
  product: "Sản phẩm",
  plPrice: "Nhập đơn giá bao gồm thuế",
  expiredAt: 'Ngày hết hạn',
  plExpiredAt: 'Chọn ngày hết hạn',
  priceExpiredAt: 'Thời hạn hiệu lực',
  days: 'Chu kỳ cung ứng (ngày)',
  plDays: 'Nhập chu kỳ cung ứng',
  mpq: 'Đóng gói tối thiểu',
  plMpq: 'Nhập đóng gói tối thiểu',
  remark: 'Ghi chú',
  plRemark: "Nhập ghi chú",
  plRemarkMax: 'Nội dung không vượt quá {{ length }} ký tự',
  priceIndex: 'Giá sản phẩm {{ index }}',
  priceCount: 'Số lượng',
  plPriceCountIndex: 'Giá bậc thang {{ index }} phải có số lượng',
  plPriceCount: 'Nhập số lượng bậc thang',
  plPriceItemIndex: 'Giá bậc thang {{ index }} phải có đơn giá bao gồm thuế',
  plPriceIndex: 'Nhập đơn giá bao gồm thuế tương ứng',
  plPriceAdd: 'Thêm giá bậc thang',
  purchaseType: 'Loại mua hàng',
  plPurchaseType: 'Chọn loại mua hàng',
  plSupplier: 'Chọn nhà cung cấp',
  plProduct: 'Chọn sản phẩm và giá',
  plProductPrice: 'Chọn sản phẩm và giá, nhập tên để tìm kiếm',
  supplier: 'Thông tin nhà cung cấp',
  productCount: 'Số lượng sản phẩm',
  plProductCount: 'Nhập số lượng sản phẩm',
  scheduledOrderTime: 'Thời gian đặt hàng dự kiến',
  plScheduledOrderTime: 'Chọn thời gian đặt hàng dự kiến',
  deliveryDeadline: 'Thời gian yêu cầu giao hàng',
  plDeliveryDeadline: 'Chọn thời gian yêu cầu giao hàng',
  estimateArrivalAt: 'Thời gian dự kiến đến',
  plEstimateArrivalAt: 'Chọn thời gian dự kiến đến',
  deliveredQuantity: 'Số lượng đã giao tích lũy',
  plDeliveredQuantity: 'Chọn số lượng đã giao',
  productDesc: 'Ghi chú từng sản phẩm',
  plProductDesc: 'Nhập ghi chú từng sản phẩm',
  orderDesc: 'Ghi chú đơn hàng',
  plOrderDesc: 'Nhập ghi chú đơn hàng',
  productInfo: 'Thông tin sản phẩm',
  orderNotExisted: "Đơn mua hàng không tồn tại",
  purchased: 'Đã đặt hàng',
  notPurchase: 'Chưa đặt hàng',
  noPurOrder: 'Chờ mua',
  orderTime: 'Thời gian đặt hàng',
  supplierInfo: 'Thông tin nhà cung cấp',
  orderList: 'Danh sách đơn mua hàng',
  addPrice: "Thêm giá sản phẩm",
  bySearchPrice: "Tìm kiếm theo mã hàng tồn kho, tên hàng tồn kho, mẫu sản phẩm",
  bySearchSupplier: 'Tìm kiếm theo mã nhà cung cấp, tên nhà cung cấp, tên viết tắt, địa chỉ',
  orderNumber: 'Số đơn hàng',
  purNo: 'Số đơn mua hàng',
  orderState: 'Trạng thái đặt hàng',
  type: 'Loại mua hàng',
  count: 'Số lượng mua',
  amount: 'Tổng chưa thuế',
  rateAmount: 'Tổng bao gồm thuế',
  priceDetail: "Thông tin giá",
  printedTip: "Đơn hàng này đã được in",
  printSelectTip: "Vui lòng chọn ít nhất một bản ghi để in",
  orderNum: "Số đơn hàng",
  orderTime1: "Ngày đặt hàng",
  currency: "Loại tiền tệ",
  demandNum: "Số đơn yêu cầu",
  quantity: "Số lượng",
  priceTax: "Đơn giá bao gồm thuế",
  totalPrice: "Tổng cộng bao gồm thuế",
  deliveryTime: "Ngày giao hàng",
  total: "Tổng cộng",
  purchase: "Mua hàng",
  review: "Thẩm định",
  signature: "Ký xác nhận của nhà cung cấp",
  createTime: "Ngày tạo",
  reviewTime: "Ngày thẩm định",
  sigTime: "Ngày ký xác nhận",
  notSelect: "Không thể chọn",
  selectPurError: "Vui lòng chọn đơn mua hàng có cùng nhà cung cấp",
  selectCurrencyError: "Vui lòng chọn đơn mua hàng có cùng loại tiền tệ",
  selectPayMethodError: "Vui lòng chọn đơn mua hàng có cùng phương thức thanh toán",
  addOrder: "Thêm đơn hàng",
  searchCode: "Tìm kiếm theo mã hàng tồn kho",
  supplierPrint: 'Nhà cung cấp',
  currencyPoint: 'Loại tiền tệ:',
  purchaseList: 'Đơn mua hàng',
  pageIndex: 'Trang {{ index }} / {{ total }}',
  printReq: 'Tạo tài liệu mua hàng',
  printRejectedFiltered: "Đã lọc các đơn hàng bị từ chối",
  printRejectedFilteredDesc: "Tự động lọc {{rejectedCount}} đơn hàng bị từ chối, còn {{validCount}} đơn hợp lệ để tạo tài liệu mua hàng.",
  printRejectedBlocked: "Không thể tạo tài liệu mua hàng",
  printRejectedBlockedDesc: "Tất cả đơn hàng được chọn đều bị từ chối. Vui lòng điều chỉnh lựa chọn và thử lại.",
  downloadFile: 'Nhấn để tải tài liệu mua hàng đã tạo',
  successFile: 'Tạo tài liệu mua hàng thành công, đang kích hoạt in cục bộ~',
  placeOrder: "Đặt hàng",
  completed: "Hoàn thành",
  plPlaceOrder: "Bạn có chắc đơn hàng này đã được đặt?",
  plPlaceOrders: "Bạn có chắc những đơn hàng này đã được đặt?",
  plOrderOk: "Bạn có chắc đơn hàng này đã hoàn thành?",
  plSeSupplier: "Chọn nhà cung cấp",
  plPlacePrice: "Chọn giá đặt hàng",
  search: "Tìm kiếm",
  clearFilters: "Xóa bộ lọc",
  materialCode: "Mã vật liệu",
  materialName: "Tên vật liệu",
  materialModel: "Mẫu vật liệu",
  purCount: "Số lượng mua",
  supplierTime: "Thời gian chuẩn bị vật liệu",
  addPurOrder: "Tạo đơn mua hàng",
  addPurOrderTip: "Tạo đơn mua hàng tự động",
  roundMethod: "Phương thức làm tròn",
  roundNone: "Không làm tròn",
  roundDown: "Làm tròn xuống",
  roundUp: "Làm tròn lên",
  roundNearest: "Làm tròn",
  addPurSuccessTip: "Tạo đơn mua hàng thành công",
  addPurSuccessTipDesc: "Tổng đơn: {{all}}, Số đơn mua tạo: {{suc}}",
  purConfirm: "Xác nhận mua hàng",
  conPur: "Xác nhận mua",
  notPur: "Tạm thời không mua",
  purCurrency: "Loại tiền mua hàng",
  curr: "Loại tiền",
  exchangeRateL: "Tỷ giá",
  purPrice: "Giá",
  purPrice_1: "Giá mua",
  purPrice_2: "Đơn giá mua",
  all: "Tổng cộng",
  supplierUserName: 'Tên tài khoản nhà cung cấp',
  supplierUser: 'Tài khoản nhà cung cấp',
  supplierReset: 'Đặt lại mật khẩu',
  initPwd: 'Mật khẩu ban đầu',
  plSupplierUser: 'Nhập tài khoản nhà cung cấp',
  supplierUserAdd: 'Thêm tài khoản nhà cung cấp',
  supplierUserSearch: 'Tìm kiếm theo tài khoản',
  resetPwd: 'Mật khẩu sẽ được đặt lại thành: {{ newPwd }}',
  resetPwdOk: 'Đặt lại mật khẩu thành công',
  editPwdError: 'Thay đổi mật khẩu thất bại',
  userList: 'Danh sách tài khoản nhà cung cấp',
  accounts: 'Tài khoản nhà cung cấp',
  ceil: "Tạm tính",
  addNoPurSuccess: "Không có đơn mua hàng mới được tạo",
  printState: 'Trạng thái in',
  unPrt: 'Chưa in',
  supplierBatchNo: 'Số lô nhà cung cấp',
  batchDeliveryNote: 'Phiếu giao hàng hàng loạt',
  batchCompletedProduction: 'Hoàn thành hàng loạt',
  batchCompleteSummary: 'Đã chọn {{selected}} bản ghi',
  batchCompleteNoAvailable: 'Không có đơn hàng nào có thể hoàn thành trong danh sách đã chọn',
  inventoryCode: 'Mã hàng tồn kho',
  supplierCode: 'Mã nhà cung cấp',
  supplierName: 'Tên nhà cung cấp',
  purchaseQuantity: 'Số lượng mua',
  supplierLot: 'Số lô nhà cung cấp',
  plSupplierLot: 'Nhập số lô nhà cung cấp',
  pleaseSelect: 'Vui lòng chọn ít nhất một bản ghi',
  pleaseSelectDeliveryTime: 'Chọn thời gian giao hàng',
  pleaseInputDeliveryCount: "Vui lòng nhập số lượng giao hàng và lot",
  leastOneMoreZero: "Ít nhất một số lượng giao hàng phải lớn hơn 0 và lot là bắt buộc",
  pleaseInputSupplierLot: 'Nhập số lô nhà cung cấp',
  batchDeliverySuccess: 'Tạo phiếu giao hàng hàng loạt thành công',
  plSupplierBatchNo: 'Nhập số lô nhà cung cấp',
  maxDeliveryQty: 'Số lượng có thể giao',
  noDeliveryData: 'Không có dữ liệu để tiếp tục tạo đơn mua',
  deliveryDate: 'Thời gian giao hàng',
  selectDeliveryDate: 'Chọn thời gian giao hàng',
  prt: 'Đã in',
  isPrted: 'Đã in chưa?',
  payMethodPoint: "Tên thỏa thuận thanh toán:",
  printCode: 'Mã hàng',
  printName: 'Tên sản phẩm',
  printModel: 'Quy cách mẫu mã',
  spec: 'Quy cách',
  printUnit: 'Đơn vị',
  printNum: 'Số lượng',
  printSPrice: 'Đơn giá bao gồm thuế',
  printPrce: 'Số tiền bao gồm thuế',
  del: 'Hủy bỏ',
  delTips: 'Thông báo hủy bỏ',
  delContent: 'Bạn có chắc muốn hủy bỏ dữ liệu này? Dữ liệu sẽ không thể khôi phục sau khi hủy bỏ!',
  state: 'Trạng thái',
  acceptType: 'Đã chấp nhận',
  rejectType: 'Đã từ chối',
  pend: 'Đang xử lý',
  rejectDetail: 'Chi tiết từ chối',
  accept: 'Chấp nhận',
  reject: 'Từ chối',
  rejectDate: 'Thời gian từ chối',
  operationPerson: 'Người thao tác',
  rejectInformate: 'Thông tin từ chối',
  comfi: 'Xác nhận chấp nhận đơn mua hàng?',
  ok: 'Xác nhận',
  cancel: 'Hủy',
  rejectComfi: 'Xác nhận từ chối đơn mua hàng?',
  reOrder: 'Chọn lại nhà cung cấp',
  operate: 'Thao tác',
  priced: "Sản phẩm này đã có báo giá hiệu lực!",
  priceManage: 'Phê duyệt báo giá',
  selectNumOver: "Tối đa chọn 10 bản ghi!",
  onOk: 'Xác nhận duyệt báo giá?',
  onReject: 'Xác nhận từ chối báo giá?',
  payMethodName: 'Thỏa thuận thanh toán',
  helpAcc: 'Hỗ trợ chấp nhận',
  sendTimePrint: 'Ngày giao hàng',
  mobilePrint: 'Số điện thoại liên hệ',
  recver: "Người liên hệ",
  seq: "Số thứ tự",
  sendNum: "Số lô giao hàng",
  outLot: "Lô xuất kho",
  sendAddress: "Địa chỉ giao hàng",
  printErr: "In thất bại",
  printDeliveryNote: "In phiếu giao hàng",
  phone1: "Số điện thoại liên hệ",
  orderDetail: "Chi tiết phiếu giao hàng",
  sendInfo: "Thông tin giao hàng",
  delivery: 'Phiếu giao hàng',
  deliveryNumber: 'Số phiếu giao hàng',
  deliveryStatus: 'Trạng thái hoàn thành',
  updatePurchaseOrderStatus: 'Cập nhật trạng thái đơn mua hàng',
  purchaseOrderStatus: 'Trạng thái đơn mua hàng',
  deliverable: 'Có thể giao hàng',
  notDeliverable: 'Không thể giao hàng',
  inState: 'Trạng thái đến hàng',
  unArrived: 'Chưa đến hàng',
  partialIn: 'Đến hàng một phần',
  allIn: 'Đã đến hàng đầy đủ',
  pendingProduction: 'Chờ sản xuất',
  inProduction: 'Đang sản xuất',
  finishedProduction: 'Đã hoàn thành sản xuất',
  completedProduction: 'Hoàn thành',
  confirmCompletedProduction: 'Xác nhận hoàn thành đơn hàng này?',
  confirmBatchCompletedProduction: 'Xác nhận hoàn thành hàng loạt các đơn hàng này?',
  markAsFinished: 'Đánh dấu là đã hoàn thành',
  confirmFinish: 'Xác nhận hoàn thành mục này?',
  complete: 'Hoàn thành',
  startProduction: 'Bắt đầu sản xuất',
  markAsFinishedProduction: 'Đánh dấu là đã hoàn thành sản xuất',
  confirmFinishProduction: 'Xác nhận đánh dấu mục này là đã hoàn thành sản xuất?',
  confirmMarkAsInProduction: 'Xác nhận đánh dấu là đang sản xuất?',
  confirmMarkAsFinished: 'Xác nhận đánh dấu là đã hoàn thành?',
  markAsInProduction: 'Đánh dấu là đang sản xuất',
  selectStatus: 'Chọn trạng thái',
  confirmMarkAsStatus: 'Xác nhận đánh dấu là <strong>{{status}}</strong>?',
  deliveryDatePlaceholder: 'Ngày giao hàng cuối cùng',
  notInStock: 'Chưa nhập kho',
  inStock: 'Đã nhập kho',
  deliveryOrders: 'Đã tạo phiếu giao hàng',
  goodName: 'Tên vật liệu',
  goodCode: 'Mã hàng tồn kho',
  goodModel: 'Mã hiệu',
  preInventory: 'Đơn nhập kho dự kiến',
  saveCodes: 'Lưu mã vạch',
  clearCodes: 'Xóa mã vạch',
  outOrder: 'Đã tạo đơn nhập/xuất kho',
  isOut: 'Đã xuất kho',
  notOut: 'Chưa xuất kho',
  hasPurOrder: 'Đã tạo đơn mua hàng',
  outOrderNumber: 'Số đơn xuất kho',
  goodsExpiredAt: 'Ngày hết hạn vật liệu',
  plGoodsExpiredAt: 'Nhập ngày hết hạn vật liệu',
  year: 'Năm',
  helpAccSuc: 'Đã hỗ trợ nhà cung cấp chấp nhận báo giá.',
  helpRejSuc: 'Đã hỗ trợ nhà cung cấp từ chối báo giá.',
  noReq: 'Không thể chọn lại nhà cung cấp!',
  noReqDesc: 'Đơn mua hàng này không có đơn thăm dò, không thể chọn lại nhà cung cấp',
  equotationRequest: 'Trạng thái đơn thăm dò',
  receivingUnit: 'Đơn vị nhận hàng',
  receivingAddress: 'Địa chỉ giao hàng',
  deliveryProgress: 'Tiến độ phiếu giao hàng',
  zfed: "Đã hủy",
  mainCurPrice: "Số tiền nội tệ",
  billingDay: "Kỳ hạn thanh toán:",
  sendAdd: "Địa chỉ giao hàng:",
  unRatePrice: "Đơn giá chưa thuế",
  nilPur: "Chưa tạo",
  purState: "Trạng thái đơn mua hàng",
  sendAds: "Địa chỉ giao hàng",
  sendAdsPl: "Chọn địa chỉ giao hàng",
  accer: "Người nhận",
  rePrt: "In lại",
  rePrtCon: "Xác nhận in lại?",
  plRePrt: "Vui lòng in lại",
  onlyOneReq: "Chỉ có thể chọn đơn hàng từ cùng một đơn yêu cầu",
  multyDown: "Tải xuống hàng loạt",
  downErr: "Tải xuống thất bại",
  leastOne: "Chọn ít nhất một bản ghi",
  inReturn: "Đã trả kho",
  stocked: "Đã nhập kho chưa?",
  selectDateError: "Chỉ có thể chọn đơn hàng có cùng thời gian giao hàng",
  spareRate: "Tỷ lệ hàng dự phòng(%)",
  spareRate_1: "Tỷ lệ hàng dự phòng",
  spareRatePl: "Nhập tỷ lệ hàng dự phòng",
  spareCount: "Số lượng hàng dự phòng",
  spareCountPl: "Nhập số lượng hàng dự phòng",
  cancelReturn: "Hủy trả kho",
  reqPur: "Đơn yêu cầu/Đơn mua hàng",
  pdaPrint: "In PDA lập đơn mua hàng",
  qcNum: "Số lượng kiểm tra",
  qcNo: "Số lượng lỗi",
  qcOk: "Kết quả kiểm tra",
  qc: "Phê duyệt",
  pg: "Quản lý chất lượng",
  cg: "Thủ kho",
  outPrint: "In đơn xuất kho",
  checkoutOrder: "Phiếu nghiệm thu",
  normalTemplate: "Mẫu thông thường",
  warehouseTemplate: "Mẫu kho hàng",
  brand: "Thương hiệu",
  plBrand: "Nhập thương hiệu",
  dictCurrency: "Loại tiền",
  printSetting: "Cài đặt in",
  otherInfo: "Nhãn vật liệu",
  originalBrand: "Tên hãng sản xuất gốc",
  originalCode: "Mã hãng sản xuất gốc",
  mpn: "Mã MPN",
  plMpn: "Nhập mã MPN",
  manufactureDate: "Ngày sản xuất gốc",
  msdLevel: "Cấp MSD",
  dcc: "D/C",
  plShelfLife: "Nhập thời hạn sử dụng",
  originPlace: "Xuất xứ",
  netWeight: "Trọng lượng tịnh",
  grossWeight: "Trọng lượng gộp",
  plOriginalBrand: "Nhập tên hãng sản xuất gốc",
  plOriginalCode: "Nhập mã hãng sản xuất gốc",
  plManufactureDate: "Nhập ngày sản xuất gốc",
  plMsdLevel: "Nhập cấp MSD",
  plOriginPlace: "Nhập xuất xứ",
  plNetWeight: "Nhập trọng lượng tịnh",
  plGrossWeight: "Nhập trọng lượng gộp",
  importSupplierPrice: 'Nhập giá nhà cung cấp',
  downloadPriceTemplate: 'Tải mẫu giá',
  importSuccess: 'Nhập thành công',
  importSuccessDesc: 'Đã nhập thành công dữ liệu giá cho {{count}} vật liệu',
  importCompleted: 'Nhập hoàn tất',
  importPartialDesc: 'Thành công {{success}}, Thất bại {{failed}} ({{failedList}})',
  fileParseError: 'Phân tích tệp thất bại, vui lòng kiểm tra định dạng tệp',
  templateWarningTitle: 'Lưu ý',
  templateWarningIntro: 'Vui lòng tuân thủ hướng dẫn điền mẫu giá:',
  templateWarning1: '1. Có thể nhập nhiều vật liệu cùng lúc, đảm bảo mã vật liệu chính xác;',
  templateWarning2: '2. Mỗi vật liệu có thể có nhiều dòng. Dòng đầu là giá cơ sở (không nhập số lượng). Các dòng tiếp theo là giá bậc thang (cần mã kho, đơn giá bao gồm thuế và số lượng);',
  templateWarning3: '3. Đảm bảo loại tiền (không phân biệt chữ hoa/thường) tồn tại trong hệ thống;',
  templateWarning4: '4. Ngày hiệu lực và ngày hết hạn phải là số 8 chữ số, ví dụ: 20260309 (09/03/2026);',
  templateWarning5: '5. Dữ liệu sai có thể gây lỗi phân tích hoặc nhập dữ liệu sai;',
  templateWarning6: '6. Cột mã nhà cung cấp là bắt buộc;',
  iHaveKnown: 'Tôi đã biết',
  confirmOrder: 'Xác nhận đặt hàng?',
  confirmOrderTip: 'Xác nhận đặt hàng?',
  incompleteRecipientInfo: 'Đơn vị nhận hàng, địa chỉ nhận hàng, người liên hệ, số điện thoại liên hệ chưa đầy đủ.',
  pleaseCompleteRecipientInfo: 'Vui lòng hoàn thiện thông tin bên nhận',
  recipientInfoDetails: 'Đơn vị nhận hàng, địa chỉ nhận hàng, người liên hệ, số điện thoại',
  syncToSupplier: 'Đồng bộ trạng thái nhà cung cấp',
  priceTemplateFileName: 'Mẫu giá nhà cung cấp',
  excelHeaderInventoryCode: 'Mã hàng tồn kho',
  excelHeaderUnitPriceIncludingTax: 'Đơn giá bao gồm thuế',
  excelHeaderMaterialValidityPeriod: 'Thời hạn vật liệu (năm)',
  excelHeaderSupplyCycle: 'Chu kỳ cung ứng (ngày)',
  excelHeaderMinimumPackage: 'Đóng gói tối thiểu',
  excelHeaderQuantity: 'Số lượng',
  excelHeaderSettlementCurrency: 'Loại tiền thanh toán',
  excelHeaderBrand: 'Thương hiệu',
  excelHeaderMpn: 'Mã MPN',
  excelHeaderShelfLife: 'D/C',
  supplierPrice: 'Giá nhà cung cấp',
  supplierHisPrice: 'Giá lịch sử nhà cung cấp',
  hisPriceExport: 'Xuất giá lịch sử',
  allPriceHis: 'Xuất tất cả giá lịch sử',
  generated: "Đã tạo",
  importInbound: "Nhập để tạo phiếu giao hàng",
  inboundTemplate: "Mẫu nhập phiếu giao hàng",
  sendTime: "Ngày giao hàng",
  inboundTemplateTip1: "1. Ngày giao hàng phải là số 8 chữ số, ví dụ: 20260311 (11/03/2026)",
  inboundTemplateTip2: "2. Nhập số lượng giao hàng của đơn mua này",
  inboundTemplateTip3: "3. Các bản ghi cùng số đơn mua và cùng ngày giao hàng sẽ được hợp nhất, cộng dồn số lượng",
  inboundTemplateTip4: "4. Dữ liệu không hợp lệ có thể gây lỗi phân tích hoặc nhập không thành công!",
  inboundTemplateTip5: "5. Cột lot có thể điền hoặc không; nếu không điền, hệ thống sẽ tự động tạo lô",
  noData: "Không có dữ liệu được phân tích",
  matchErr: "Khớp dữ liệu đơn mua thất bại, vui lòng thử lại!",
  importDone: "Nhập hoàn tất",
  succNum: "Số lượng thành công",
  importErrTip: "Các đơn mua sau cần kiểm tra dữ liệu",
  maxQuantityErr: "Tổng số lượng giao của các đơn mua sau vượt quá số lượng có thể giao",
  excelCount: "Tổng số lượng giao",
  purNoErr: "Dòng {{index}}: Lỗi kiểm tra số đơn mua",
  countErr: "Dòng {{index}}: Lỗi số lượng giao",
  preTimeErr: "Dòng {{index}}: Lỗi thời gian giao",
  importErr: "Khớp dữ liệu thất bại, không có dữ liệu được nhập",
  notPurNo: 'Các đơn mua sau không tồn tại',
  numAdds: 'Tổng số lượng',
  rateNumAdds: 'Tổng tiền bao gồm thuế',
  ratePceAdds: 'Tổng đơn giá bao gồm thuế',
  toReturn: "Chờ trả kho",
  returnQty: "Số lượng trả hàng",
  actualArrivalQty: "Số lượng thực tế đến",
  actualArrivalTime: "Thời gian thực tế đến",
  undeliveredQty: "Số lượng chưa giao",
  orderNums: "Số lượng phiếu giao hàng",
  importSuppOrders: "Nhập để tạo phiếu giao hàng nhà cung cấp",
  allSendQty: "Tổng số lượng giao",
  sentQty: "Số lượng đã giao",
  sendQty: "Số lượng giao lần này",
  remainQTy: "Số lượng giao còn lại",
  noSendInfo: "Không có thông tin giao hàng",
  fileLoss: "Thiếu tệp nguồn nhập!",
  import: "Nhập dữ liệu mẫu",
  matchPur: "Khớp đơn mua",
  done: "Hoàn tất",
  thdCode: "Mã khách hàng MES",
  plThdCode: "Nhập mã khách hàng MES",
  batchSubmit: 'Báo giá hàng loạt',
  batchSubmitSucc: 'Báo giá hàng loạt thành công',
  batchSubmitErr: 'Báo giá hàng loạt thất bại',
  needPriceTip: 'Dữ liệu sau cần nhập giá thủ công',
  batchSubmitTip: 'Xác nhận báo giá cho các đơn thăm dò đã chọn?',
  actualInboundTime: "Thời gian nhập kho thực tế",
  supplierCodeNeed: "Mã nhà cung cấp không tồn tại ở dòng {{index}}, phân tích thất bại",
  addRule: "Thêm điều khoản giao dịch đơn mua hàng?",
  effectiveAt: "Ngày hiệu lực",
  expiredAtEcl: "Ngày hết hạn",
  effectiveAtPl: "Chọn ngày hiệu lực",
  expiredAtEclPl: "Chọn ngày hết hạn",
  purOrderPl: "Chọn đơn mua hàng",
  notApi: "Nhà cung cấp này chưa cấu hình API, không thể chuyển đơn!",
  swapData: "Dữ liệu chuyển đơn",
  swapDone: "Chuyển đơn hoàn tất",
  notSuppPros: "Các sản phẩm này không tồn tại trong hệ thống nhà cung cấp. Vui lòng thêm chúng vào hệ thống nhà cung cấp.",
  notSaleProPrice: "Giá khách hàng cuối không tồn tại trong hệ thống nhà cung cấp. Vui lòng thêm các giá khách hàng này.",
  purchaseTransferSuccess: "Chuyển đơn mua hàng thành đơn bán hàng hoàn tất",
  noRejected: "Đơn mua hàng này đã bị từ chối, không thể chuyển đơn!",
  swapErr: "Chuyển đơn thất bại",
  startSwap: "Bắt đầu chuyển đơn",
  priceComputedTip: "Số lượng sản phẩm hoặc thuế suất đã thay đổi, cần tính lại giá.",
  selectPurErrorTip: "Vui lòng chọn các mục có cùng nhà cung cấp, cùng loại tiền thanh toán và cùng phương thức thanh toán",
  notResolved: "Đơn mua hàng này không ở trạng thái đã chấp nhận, không thể chọn",
  printedTipErr: "Các mục sau đã được in, không thể in tiếp",
  downloadTip: "PDF đã tạo xong. Tải xuống không?",
  pdfIng: "Đang tạo PDF",
  addPurchaseOrder: "Thêm đơn mua hàng",
  addItem: "Thêm dòng đơn hàng",
  item: "Dòng đơn hàng",
  items: "Dòng đơn hàng",
  plCurrency: "Vui lòng chọn loại tiền tệ",
  plPayMethod: "Vui lòng chọn phương thức thanh toán",
  ladderPrice: "Giá bậc thang",
  ladderPriceCount: "Số lượng",
  productType: "Loại sản phẩm",
  brandName: "Tên thương hiệu",
  brandModel: "Mẫu thương hiệu",
};

export default purchase;
